<div class="rounded-4 bg-white border p-3 attribute-card d-flex flex-column gap-2 h-100">
  <h2 class="mb-2">Linked Co Buyers</h2>
  @if (canWriteDeals()) {
    <button class="btn btn-primary btn-h42 ms-auto" (click)="openAddCoBuyerModal()">
      <i class="bi bi-person-plus"></i>
      Add Co-Buyer
    </button>
  }

  <div class="flex-fill h-100 overflow-hidden">
    <div class="table-outer table-theme">
      <div class="table-responsive h-100">
        <p-table #dt [value]="linkedCoBuyers()" sortMode="single">
          <ng-template #header>
            <tr>
              <th pSortableColumn="coBuyer.firstName">
                Name
                <i
                  class="bi ms-1"
                  [ngClass]="
                    dt.sortField === 'coBuyer.firstName'
                      ? dt.sortOrder === 1
                        ? 'bi-arrow-up text-primary'
                        : 'bi-arrow-down text-primary'
                      : 'bi-arrow-down-up text-secondary'
                  "
                  aria-hidden="true"
                ></i>
              </th>
              <th pSortableColumn="coBuyer.email">
                Email
                <i
                  class="bi ms-1"
                  [ngClass]="
                    dt.sortField === 'coBuyer.email'
                      ? dt.sortOrder === 1
                        ? 'bi-arrow-up text-primary'
                        : 'bi-arrow-down text-primary'
                      : 'bi-arrow-down-up text-secondary'
                  "
                  aria-hidden="true"
                ></i>
              </th>
              <th>Phone</th>
              <th>Add to Mailing List</th>
              <th>Include in Contract</th>
              <th width="150px"></th>
            </tr>
          </ng-template>
          <ng-template #body let-coBuyer>
            <tr>
              <td>{{ getFullName(coBuyer) }}</td>
              <td>
                @if (coBuyer.coBuyer.email) {
                  <a [href]="'mailto:' + coBuyer.coBuyer.email" class="text-decoration-none">{{
                    coBuyer.coBuyer.email
                  }}</a>
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td>
                @if (coBuyer.coBuyer.phone?.phoneNumber) {
                  {{ coBuyer.coBuyer.phone.phoneNumber }}
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <td>
                <p-toggleswitch
                  [ngModel]="coBuyer.addToMailingList"
                  [disabled]="!canWriteDeals()"
                  (ngModelChange)="onToggleAddToMailingList(coBuyer, $event)"
                />
              </td>
              <td>
                <p-toggleswitch
                  [ngModel]="coBuyer.includeInContract"
                  [disabled]="!canWriteDeals()"
                  (ngModelChange)="onToggleIncludeInContract(coBuyer, $event)"
                />
              </td>
              <td>
                @if (canWriteDeals()) {
                  <a href="javascript:void(0)" (click)="onUnlinkCoBuyer(coBuyer)">
                    <i class="bi bi-link-45deg lh-1 me-2"></i>Unlink
                  </a>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="6" class="text-center">No linked co-buyers found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<ng-template #addCoBuyerModal let-modal>
  @if (prospectId()) {
    <add-co-buyer-modal [prospectIdInput]="prospectId()!" (reload)="coBuyerUnlinked.emit()"></add-co-buyer-modal>
  }
</ng-template>
